import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { Bespoke } from "../components/site/Sections";

export default function BespokePage() {
  return (
    <>
      <SEO
        title="Bespoke & Custom-Branded Products for Hospitality | Emporium London"
        description="Custom-branded decor and gifting for hotels, restaurants and corporates — bespoke materials, colour matching, engraving, embossing and packaging, produced at the volumes you need."
        path="/bespoke"
      />
      <main>
        <PageHeader
          overline="Bespoke &amp; Custom Products"
          title="Custom-branded objects, made to your theme"
          intro="From materials and colourways to engraving and packaging, we produce bespoke decor and gifting matched precisely to your brand and interior."
        />
        <Bespoke />
      </main>
    </>
  );
}
